import Shop from './shop/reducer';
import {combineReducers} from 'redux';

export default combineReducers({
  Shop
}); 